module.exports = __webpack_public_path__ + "static/media/claim.935f5c6c.png";